// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuBar_sidebar__yZhYX{
    display: flex;
    width: 150px;
    flex-direction: column;
}

.SideMenuBar_sidebar__yZhYX a {
    align-items: center;
    border-radius: 0px 16.842px 16.842px 0px;
    align-self: stretch;
    display: flex;
    padding-top: 13px;
    padding-right: 20px;
    padding-bottom: 13px;
    padding-left: 20px;
    flex-direction: column;
    margin-top: 10px;
    width: 100%;
    height: 23px;
    text-decoration: none;
}

.SideMenuBar_sidebar__yZhYX a.SideMenuBar_active__rnpTs {
    align-items: center;
    border-radius: 0px 16.842px 16.842px 0px;
    background-color: var(--Secondary, #274C77);
    align-self: stretch;
    display: flex;
    width: 100%;
    padding-top: 13px;
    padding-right: 20px;
    padding-bottom: 13px;
    padding-left: 20px;
    flex-direction: column;
}
  
.SideMenuBar_sidebar__yZhYX a:hover:not(.SideMenuBar_active__rnpTs) {
    background-color: #dbdbdb;
    color: white;
    align-items: center;
    border-radius: 0px 16.842px 16.842px 0px;
    align-self: stretch;
    display: flex;
    padding-top: 13px;
    padding-right: 20px;
    padding-bottom: 13px;
    padding-left: 20px;
    flex-direction: column;
}

.SideMenuBar_menuOptionTextDiv__QY\\+P0{
    align-self: center;
    display: flex;
    margin-left: -16px;
    width: 200px;
    max-width: 100%;
    align-items: flex-start;
    gap: 18px;
}

.SideMenuBar_menuIcon__4fw27 {
    aspect-ratio: 0.96;
    object-fit: cover;
    object-position: center;
    width: 25px;
    overflow: hidden;
    align-self: start;
    fill: #274C77;
}

.SideMenuBar_menuOptionText__po-QB{
    color: var(--Primary, #E7ECEF);
    font-family:
        Lato, sans-serif;
    font-size: 12px;
    font-weight: 600;
    align-self: center;
    margin-top: auto;
    margin-bottom: auto;
    text-wrap: nowrap;
    @media (max-width: 991px) {
        textWrap: initial
    }
}

.SideMenuBar_menuOptionTextNotActive__WDapa{
    color: var(--Primary, #E7ECEF);
    font-family:
        Lato, sans-serif;
    font-size: 12px;
    font-weight: 600;
    align-self: center;
    margin-top: auto;
    margin-bottom: auto;
    text-wrap: nowrap;
    @media (max-width: 991px) {
        textWrap: initial
    }
    color: var(--Secondary, #274C77);
}`, "",{"version":3,"sources":["webpack://./src/components/SideMenuBar.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B;wBACoB;IACpB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB;QACI;IACJ;AACJ;;AAEA;IACI,8BAA8B;IAC9B;wBACoB;IACpB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB;QACI;IACJ;IACA,gCAAgC;AACpC","sourcesContent":[".sidebar{\n    display: flex;\n    width: 150px;\n    flex-direction: column;\n}\n\n.sidebar a {\n    align-items: center;\n    border-radius: 0px 16.842px 16.842px 0px;\n    align-self: stretch;\n    display: flex;\n    padding-top: 13px;\n    padding-right: 20px;\n    padding-bottom: 13px;\n    padding-left: 20px;\n    flex-direction: column;\n    margin-top: 10px;\n    width: 100%;\n    height: 23px;\n    text-decoration: none;\n}\n\n.sidebar a.active {\n    align-items: center;\n    border-radius: 0px 16.842px 16.842px 0px;\n    background-color: var(--Secondary, #274C77);\n    align-self: stretch;\n    display: flex;\n    width: 100%;\n    padding-top: 13px;\n    padding-right: 20px;\n    padding-bottom: 13px;\n    padding-left: 20px;\n    flex-direction: column;\n}\n  \n.sidebar a:hover:not(.active) {\n    background-color: #dbdbdb;\n    color: white;\n    align-items: center;\n    border-radius: 0px 16.842px 16.842px 0px;\n    align-self: stretch;\n    display: flex;\n    padding-top: 13px;\n    padding-right: 20px;\n    padding-bottom: 13px;\n    padding-left: 20px;\n    flex-direction: column;\n}\n\n.menuOptionTextDiv{\n    align-self: center;\n    display: flex;\n    margin-left: -16px;\n    width: 200px;\n    max-width: 100%;\n    align-items: flex-start;\n    gap: 18px;\n}\n\n.menuIcon {\n    aspect-ratio: 0.96;\n    object-fit: cover;\n    object-position: center;\n    width: 25px;\n    overflow: hidden;\n    align-self: start;\n    fill: #274C77;\n}\n\n.menuOptionText{\n    color: var(--Primary, #E7ECEF);\n    font-family:\n        Lato, sans-serif;\n    font-size: 12px;\n    font-weight: 600;\n    align-self: center;\n    margin-top: auto;\n    margin-bottom: auto;\n    text-wrap: nowrap;\n    @media (max-width: 991px) {\n        textWrap: initial\n    }\n}\n\n.menuOptionTextNotActive{\n    color: var(--Primary, #E7ECEF);\n    font-family:\n        Lato, sans-serif;\n    font-size: 12px;\n    font-weight: 600;\n    align-self: center;\n    margin-top: auto;\n    margin-bottom: auto;\n    text-wrap: nowrap;\n    @media (max-width: 991px) {\n        textWrap: initial\n    }\n    color: var(--Secondary, #274C77);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `SideMenuBar_sidebar__yZhYX`,
	"active": `SideMenuBar_active__rnpTs`,
	"menuOptionTextDiv": `SideMenuBar_menuOptionTextDiv__QY+P0`,
	"menuIcon": `SideMenuBar_menuIcon__4fw27`,
	"menuOptionText": `SideMenuBar_menuOptionText__po-QB`,
	"menuOptionTextNotActive": `SideMenuBar_menuOptionTextNotActive__WDapa`
};
export default ___CSS_LOADER_EXPORT___;
